import { Link } from "react-router-dom";

import { BLOGS } from "@/lib/blogs";
import { useSeoMeta } from "@/lib/useSeoMeta";

export default function BlogsPage() {
  useSeoMeta({
    title: "Docs — SkillPatch",
    description: "Guides and ideas on building with agentic skills.",
    path: "/docs",
  });
  return (
    <main className="mx-auto max-w-[1300px] px-10 py-12">
      <h1 className="font-display text-3xl font-bold tracking-tight">Docs</h1>
      <p className="mt-1.5 text-text/50">Guides and ideas on building with agentic skills.</p>

      <div className="mt-8 space-y-4">
        {BLOGS.map((b) => (
          <Link
            key={b.slug}
            to={`/docs/${b.slug}`}
            className="group block rounded-2xl border border-white/10 bg-white/[0.02] p-6 transition hover:-translate-y-0.5 hover:border-primary/50 hover:bg-white/[0.04]"
          >
            <h2 className="font-display text-xl font-semibold transition group-hover:text-primary">{b.title}</h2>
            <p className="mt-2 text-sm leading-relaxed text-text/60">{b.description}</p>
            <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-accent">
              Read
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </span>
          </Link>
        ))}
      </div>
    </main>
  );
}
